import { SCAN_ACTION_FAILURE_ACTION_NAME } from '../constants/scanActionNames.const';
import {
  type CreateScanActionFailureScanActionOptions,
  type ScanAction,
  type ScanActionResult,
} from '../types/scanAction.type';
import { type ScanEvent } from '../types/scanEvent.type';
import { createScanActionResolutionError } from '../utils/scanActionError.util';

export const createScanActionFailureScanAction = ({
  isScanToPrintEnabled = () => false,
  notifyError,
}: CreateScanActionFailureScanActionOptions = {}): ScanAction => ({
  execute: (
    scanEvent: ScanEvent,
    error: Error = createScanActionResolutionError(scanEvent.correlation_id),
  ): ScanActionResult => {
    if (isScanToPrintEnabled() && !scanEvent.scan_context.barcode_content) notifyError?.();

    return { error, success: false };
  },

  matches: () => true,

  name: SCAN_ACTION_FAILURE_ACTION_NAME,
});
